import React, { useEffect } from "react";
import Header from "../../components/layout/Header";
import Footer from "../../components/layout/Footer";
import Hero from "../../components/About/hero/Hero";
import { RESOURCES } from "../../data/resources";
import { GuideBottom } from "../../components/Home/Guide/Guide";
import { Animate, Stagger } from "../../components/animations";

function Resources() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <Hero heading="Resources & Guides" />
      <section className="layout-section">
        <div className="layout-container layout-container--narrow">
          <Animate variant="fadeUp">
            <p className="text-center text-gray-600 mb-12">
              Expert guides, tips, and insights to help you navigate your study-abroad journey.
            </p>
          </Animate>
          <Stagger className="space-y-6" variant="slideLeft" stagger={90}>
            {RESOURCES.map((resource) => (
              <article
                key={resource.id}
                className="border rounded-lg overflow-hidden hover:shadow-md transition-shadow cursor-pointer flex flex-col sm:flex-row anim-hover-lift bg-white"
              >
                <img
                  src={resource.image}
                  alt={resource.title}
                  className="w-full sm:w-48 h-40 sm:h-auto object-cover flex-shrink-0"
                />
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-2 flex-wrap">
                    <span className="bg-blue-100 text-blue-700 text-xs font-semibold px-3 py-1 rounded-full">
                      {resource.category}
                    </span>
                    <span className="text-gray-400 text-sm">{resource.date}</span>
                    <span className="text-gray-400 text-sm">· {resource.readTime}</span>
                  </div>
                  <h2 id="heading-md" className="hover:text-blue-600 transition-colors">
                    {resource.title}
                  </h2>
                  <p className="text-gray-600 mt-2">{resource.excerpt}</p>
                </div>
              </article>
            ))}
          </Stagger>
          <Animate variant="fadeUp" delay={100}>
            <p className="text-center text-gray-500 mt-8">
              More guides coming soon. Subscribe to our newsletter for updates.
            </p>
          </Animate>
        </div>
      </section>
      <Animate variant="fadeUp">
        <GuideBottom />
      </Animate>
      <Footer />
    </>
  );
}

export default Resources;
